<template>
  <div class="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
    </div>
    <iframe :src="url" width="100%" class="user-agreement"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang:'cn',
      closeImage: require("@/assets/close.png"),
      width: "100%",
      height: "100vh",
      url: "https://www.xuanjiai.cn/app/privacy.html",
    };
  },
  mounted(){
    this.lang = localStorage.getItem('lang') || 'cn'
    if(this.lang ==='cn') {
      this.url = 'https://www.xuanjiai.cn/app/privacy.html'
    } else {
      this.url = 'https://www.xuanjiai.cn/app/privacy_en.html'
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>

<style scoped>
.app{
    height: 100vh;
    text-align: left;
    overflow: hidden;
    padding:0px 16px
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.user-agreement {
  height: calc(100vh - 44px);
  border: none;
  overflow: hidden;
}
iframe {
  overflow: hidden;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
</style>